import { withTranslation } from 'react-i18next';
import { PDFDownloadLink } from "@react-pdf/renderer";
import {  MenuItem, ListItemIcon, ListItemText } from '@mui/material/';
import PDFIcon from '../Icons/PDFIcon.js';
import { RaportLayout } from './RaportLayout.js' 

function PureDownloadPDFmenuItem({ t, deviceData, rebootTime, dateNow, range, charts, referece, closeFn }) {
  const fileName = `${deviceData.name.replace(/\s/g, '')}-${dateNow}.pdf`;

  console.log("DownloadPDFmenuItem params:", deviceData, rebootTime, dateNow, range, charts, referece, closeFn);
  return (
    <PDFDownloadLink 
      fileName={fileName}
      document={
        <RaportLayout
          deviceData={deviceData}
          rebootTime={rebootTime}
          dateNow={dateNow}
          range={range} 
          charts={charts}
        />
      }
    >
      {({ loading }) => (
        <MenuItem
          onClick={closeFn}
          disabled={loading}
        >
          <ListItemIcon>
            <PDFIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{loading ? t('generating-report-pdf') : t('download-report-pdf')}</ListItemText>
        </MenuItem>
      )}
    </PDFDownloadLink>
  );
}
  {/* { charts.length === 0 &&
          <Box sx={{my:1}} >
            <Button
              onClick={ generatePDFRaport }
              variant="outlined"
              disabled={ isLoading || isError || data?.length === 0 || data == null}
              endIcon={<PDFIcon />}
              >
              {t('generate-report-pdf')}
            </Button>
          </Box>
        }
        <Box sx={{my:1}}>
          <DownloadReport
            deviceData={deviceData}
            rebootTime={formatTime(referenceTime, 'DATETIME_SHORT', language, hourCycle, offset)}
            dateNow={dateNow}
            range={{start: data?.[0]?.name, end: data?.[data?.length - 1]?.name}}
            charts={charts}
            referece={reportDownloadButtonRef}
            disabled={ isLoading || !isSuccess || charts.length === 0  }
          />
        </Box> */}
  // const fileName = `${deviceData.name.replace(/\s/g, '')}-${dateNow}.pdf`
  // return (
  //   <PDFDownloadLink 
  //     fileName={fileName}
  //     document={
  //       <RaportLayout
  //         deviceData={deviceData}
  //         rebootTime={rebootTime}
  //         dateNow={dateNow}
  //         range={range} 
  //         charts={charts}
  //     />} 
  //   >
  //     { charts.length > 0 &&
  //       <Button
  //         color="secondary"
  //         ref={referece}
  //         variant="outlined" 
  //         style={{  }}
  //         disabled={ disabled }
  //         endIcon={<PDFIcon/>}
  //       >
  //         {t('download-report-pdf')}
  //       </Button>
  //     }
  //   </PDFDownloadLink>
  // );

const DownloadPDFmenuItem = withTranslation()(PureDownloadPDFmenuItem);
export default DownloadPDFmenuItem;